/**
 * search Group
 * @param fb : FormBuilder
 */
export function searchGroup (fb: any):any {
    return fb.control('')
}
